export default __webpack_public_path__ + "media/images/Message_16x16-9685d96bb83aff0e5da378a146cdbd30.png";